import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import api from "../../service/api";
import { toast } from "react-toastify";
import { belemApi } from "../../services/belemApi";



import Calendar from "../../img/calendar.svg";
import Recovery from "../../img/refresh-ccw.svg";
import Excluir from "../../img/file-x-2.svg";
import Cartao from "../../img/cartao.png";

export default function Home() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleIniciar() {
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await api.post(`/api/mosqueiro`);
      // opcional: inativar vagas sem travar navegação
      api.post(`/api/mosqueiro/inativaVagas`).catch(() => {});

      if (data?.status === true) {
        navigate("/pesquisaEscola");
      } else {
        toast.error("Não existe data para agendamento");
      }
    } catch (err) {
      toast.error("Falha ao iniciar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="min-h-screen flex flex-col bg-white">
      {/* Hero */}
      <section className="pt-20 sm:pt-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h1 className="text-center text-2xl sm:text-3xl lg:text-4xl font-medium text-outra leading-tight">
            Atendimento exclusivo para os alunos de Mosqueiro
          </h1>
        </div>
      </section>

      {/* Conteúdo principal */}
      <section className="flex-1 py-8 sm:py-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Imagem lateral */}
            <div className="order-2 lg:order-1 flex justify-center">
              <img
                src={Cartao}
                alt="Cartão PasseFácil"
                className="w-56 sm:w-72 md:w-80 h-auto object-contain drop-shadow"
                loading="lazy"
                decoding="async"
              />
            </div>

            {/* Ações */}
            <div className="order-1 lg:order-2">
              <div
                className="
                  grid
                  grid-cols-1
                  sm:grid-cols-2
                  lg:grid-cols-3
                  gap-5 sm:gap-6
                "
              >
                {/* Iniciar */}
                <button
                  type="button"
                  onClick={handleIniciar}
                  disabled={loading}
                  className={`
                    group relative w-full rounded-xl bg-base-Card p-5
                    shadow-sm ring-1 ring-green-base/20
                    transition
                    hover:-translate-y-0.5 hover:shadow-lg hover:bg-card3
                    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-card3
                    ${loading ? "opacity-70 cursor-not-allowed" : "cursor-pointer"}
                  `}
                  aria-label="Iniciar Agendamento"
                >
                  <img
                    src={Calendar}
                    alt=""
                    className="mx-auto h-24 sm:h-28 mb-3"
                    aria-hidden="true"
                  />
                  <h2 className="text-center text-letras2 text-lg sm:text-xl font-abc font-bold">
                    {loading ? "Iniciando..." : "Iniciar Agendamento"}
                  </h2>
                </button>

                {/* Excluir */}
                <Link
                  to="/excluir"
                  className="
                    group relative w-full rounded-xl bg-base-Card p-5
                    shadow-sm ring-1 ring-green-base/20
                    transition
                    hover:-translate-y-0.5 hover:shadow-lg hover:bg-card3
                    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-card3
                  "
                  aria-label="Excluir Agendamento"
                >
                  <img
                    src={Excluir}
                    alt=""
                    className="mx-auto h-24 sm:h-28 mb-3"
                    aria-hidden="true"
                  />
                  <h2 className="text-center text-letras2 text-lg sm:text-xl font-abc font-bold">
                    Excluir Agendamento
                  </h2>
                </Link>

                {/* Recuperar */}
                <Link
                  to="/recuperar"
                  className="
                    group relative w-full rounded-xl bg-base-Card p-5
                    shadow-sm ring-1 ring-green-base/20
                    transition
                    hover:-translate-y-0.5 hover:shadow-lg hover:bg-card3
                    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-card3
                  "
                  aria-label="Recuperar Agendamento"
                >
                  <img
                    src={Recovery}
                    alt=""
                    className="mx-auto h-20 sm:h-24 mb-3"
                    aria-hidden="true"
                  />
                  <h2 className="text-center text-letras2 text-lg sm:text-xl font-abc font-bold">
                    Recuperar Agendamento
                  </h2>
                </Link>
              </div>

            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
